/**
 * Focus modality
 *
 * Safari/WebKit match :focus-visible when a link or button is clicked
 * with a pointer (e.g. cmd-click, or mailto: links where focus stays on
 * the element), so the focus ring shows on click. To avoid that we flag
 * pointer interaction on <html> and suppress the ring while it's set
 * (see base/_focus.scss). Keyboard focus re-enables the ring on Tab.
 *
 * Degrades safely: if this never runs, :focus-visible still shows the
 * keyboard focus ring as normal.
 */
export default function Focus() {
	const root = document.documentElement

	const usePointer = () => root.classList.add('using-pointer')

	const useKeyboard = (event) => {
		if (event.key === 'Tab') {
			root.classList.remove('using-pointer')
		}
	}

	// Capture phase so the flag is set before focus styles are evaluated.
	document.addEventListener('mousedown', usePointer, true)
	document.addEventListener('pointerdown', usePointer, true)
	document.addEventListener('touchstart', usePointer, true)
	document.addEventListener('keydown', useKeyboard, true)
}
